<script>
export default {
  props: {
    currentQuestion: Object,
    is_instruksi: Number,
    mengerjakan: Function,

    // Jawaban
    // currentQuestion: Object,
    hasImageOptions: Boolean, 
    // mengerjakan: Function,
  },

  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      abjad : ["A", "B", "C", "D"],
      selectedIndex: null,
    };
  },
  
};
</script>

<template>
  <div class="mym-question-body">
    <!-- NUMBER -->
    <div class="mym-question-navigation">
      <div class="mym-question-section">
        <div class="mb-2">
          <div>
            <h4>
              Petunjuk Pilihan Ganda
            </h4>
          </div>

          <div>
            <p>
              Silahkan pilih salah satu jawaban dengan klik pada pilihan jawaban
              yang tersedia.
            </p>
          </div>

          <p>Klik "preview" untuk menampilkan gambar</p>
        </div>

        <div class="mb-3">
          <b>Contoh Soal</b>
          <p>{{ currentQuestion.soal_text }}</p>
        </div>

        <div class="mb-3">
          <img
            v-if="currentQuestion?.soal_image"
            :src="BACKEND_URL + currentQuestion?.soal_image"
            class="mym-question-image"
          />
          <div class="mym-question-text">
            {{ currentQuestion?.pertanyaan }}
          </div>
        </div>
      </div>
    </div>

    <!-- ================= OPTIONS SECTION ================= -->
    <div class="mym-options-section">
      <div class="mym-options" :class="{ 'grid-mode': hasImageOptions }">
        <div
          v-for="(jawaban, i) in currentQuestion?.jawaban"
          :key="i"
          class="mym-option-card"
          :class="{ active: selectedIndex === i }"
          @click="selectedIndex = i"
        >
          <!-- @click="localAnswers[currentIndex] = opt.kode_jawaban" -->

          <img v-if="jawaban?.image" :src="jawaban?.image" class="option-image" />

          <div class="option-content">
            <div class="option-label">
              <span v-if="selectedIndex === i">✔</span>
              <!-- <span v-else>{{ jawaban.kode_jawaban }}</span> -->
               <span v-else>{{ abjad[i] }}</span>
            </div>

            <div class="option-text">
              {{ jawaban?.jawaban }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>